import React from 'react';
import Select from 'react-select';

import ClearIndicator from './selects/ClearIndicator';
import styles, { theme } from './selects/defaultSelectStyles';
import DropdownIndicator from './selects/DropdownIndicator';
import NoOptionsMessage from './selects/NoOptionsMessage';

function VersatileSelect(props) {
    const customComponents = {
        DropdownIndicator,
        NoOptionsMessage,
        ClearIndicator
    };
    if (!props.isMulti) {
        customComponents.IndicatorSeparator = null;
    }
    return <Select components={customComponents} styles={styles} theme={theme} {...props} />;
}

VersatileSelect.propTypes = {};

export default VersatileSelect;
